(function($) {
  $('.banner-slider').slick({
    fade: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
  }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // console.log(slick);
    $('.landing .anime').removeClass('anime-run');
  }).on('afterChange', function(event, slick, currentSlide){
    // console.log(currentSlide);
    $('.landing .anime').addClass('anime-run');
    // if (currentSlide != 6) {
      // setTimeout(() => {
      // }, 400);
    // }
  });
  $('.gallery-slider').slick({
    variableWidth: true,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 4000,
  });
  // initPhotoSwipeFromDOM('.gallery');
})($);